import { Component, Input } from '@angular/core';
import { BookingSlot } from '../../../booking/models/booking-slot';
import { TimeSlotDisplayType } from '../../models/time-slot-display-type.enum';
import { ShopSettingsService } from '../../services/shop-settings.service';

@Component({
  selector: 'app-time-slot-box',
  templateUrl: './time-slot-box.component.html',
  styleUrls: ['./time-slot-box.component.css']
})
export class TimeSlotBoxComponent {

  @Input()
  bookingSlot: BookingSlot;

  constructor(
    private shopSettingsService: ShopSettingsService,
  ) {
  }

  get isDefaultTimeSlot(): boolean {
    return this.timeSlotDisplayType === TimeSlotDisplayType.Default;
  }

  get isTimePeriodTimeSlot(): boolean {
    return this.timeSlotDisplayType === TimeSlotDisplayType.TimePeriod;
  }

  get timeSlotDisplayType(): string {
    return this.shopSettingsService?.shopSettings?.timeSlotDisplayType || TimeSlotDisplayType.Default;
  }

}
